<template>
	<div class="box">
		<!-- <div  class="head">
			oops! page not found
		</div> -->
		<div class="content">
			404
		</div>
		<!-- <div class="btn">
			go back home
		</div> -->
	</div>
</template>

<script>
export default {
	
}
</script>

<style  lang="less">
body{
			/* background: linear-gradient(125deg, blue, green 40%, red); */
			background-color: #ccc;
			width: 100vw;
			height: 100Vh;
		}
		.box{
			position: absolute;
			top: 50%;
			left: 50%;
			text-align: center;
			transform: translate(-50%,-50%);
		}
		.head{
			font-size: 20px;
			color: #242424;
		}
		.content{
			margin: 20px;
			font-size: 150px;
			font-weight: 900;
			letter-spacing: 20px;
			background: url(../../../public/img/4.jpg) center no-repeat;
			background-size: 100% 100%;
			-webkit-background-clip: text;
			-webkit-text-fill-color:transparent
		}
		.btn{
			font-size: 20px;
			background-color:#FF9933 ;
			color:#fff;
			display: inline-block;
			border-radius:10px;
			padding: 12px 24px;
		}
</style>
